module.exports = __webpack_public_path__ + "img/medium.e4f99f14.png";